var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurplehat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 714 362.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a389a3;}.cls-2{fill:#705d6f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211,195.5l67.6-84.25c10.91-13.59,29.23-21.75,48.84-21.75H445.65c17.56,0,34.2,6.55,45.36,17.85l78,93.15Z",
    transform: "translate(-27 -89.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M384,155.5c-197.17,0-357,82.38-357,184,0,42.41,27.85,81.47,74.64,112.59C106,406.64,121,330.35,172.78,284.54c35.58-31.5,73.66-53.92,107.57-65.38h0a184.7,184.7,0,0,1,21.53-5.92c32.92-8,98.77-20,163.19-7.84h0c41.21,5.42,94.76,35.14,142.26,82.64,47.16,47.16,60,117.43,63.1,161.29C714.76,418.67,741,380.66,741,339.5,741,237.88,581.17,155.5,384,155.5Z",
    transform: "translate(-27 -89.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplehat);
export default __webpack_public_path__ + "static/media/purple hat.23ece0b1.svg";
export { ForwardRef as ReactComponent };